@if (isVisible && banner) {
    <div class="banner-{{ type }} {{ typeClass }} {{ order }}">
        @if (ofType(banner, 'CasinoLink')) {
            <ms-casino-banner-link [model]="banner" [position]="position" />
        } @else if (ofType(banner, 'SportLink')) {
            <ms-sport-banner-link [model]="banner" [position]="position" />
        } @else if (ofType(banner, 'Jackpot')) {
            <ms-banner-jackpot [model]="banner" [position]="position" />
        } @else if (ofType(banner, 'Games')) {
            <ms-banner-games [model]="banner" [position]="position" />
        } @else if (ofType(banner, 'Vyml') && isVymlEnabled) {
            <ms-vyml [model]="banner" [position]="position" [pageName]="pageName" />
        } @else if (ofType(banner, 'Esport')) {
            <ms-banner-esport [model]="banner" />
        }
    </div>
}
